import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageModule, LinkModule } from '@com-delta-idp/mnx-ui-kit';
import { PartnersComponent as AuraPartnersComponent } from '@com-delta-omnichannel/aura';
import { PartnersComponent } from './partners.component';

@NgModule({
  declarations: [PartnersComponent],
  imports: [CommonModule, ImageModule, LinkModule, AuraPartnersComponent],
  exports: [PartnersComponent]
})
export class PartnersModule {}
